export enum SettingsRoleEnum {
  lab = 'lab',
  user = 'user',
  dev = 'dev',
}
